import { defineComponent, computed } from "vue";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset-0dfbd395.mjs";
const _sfc_main = defineComponent({
  name: "VaListSeparator",
  props: {
    ...useComponentPresetProp,
    fit: { type: Boolean, default: false },
    spaced: { type: Boolean, default: false }
  },
  setup: (props) => ({
    computedClass: computed(() => ({
      "va-list-separator--offset": !props.fit,
      "va-list-separator--spaced": props.spaced
    }))
  })
});
export {
  _sfc_main as _
};
//# sourceMappingURL=VaListSeparator.vue_vue_type_script_lang-18631fea.mjs.map
